import { ReportCallback, ReportOpts } from 'web-vitals';

const reportWebVitals = (onPerfEntry?: ReportCallback, opts?: ReportOpts) => {
    if (onPerfEntry && onPerfEntry instanceof Function) {
        import('web-vitals').then(({ onLCP, onINP, onCLS }) => {
            onLCP(onPerfEntry, opts);
            onINP(onPerfEntry, opts);
            onCLS(onPerfEntry, opts);
        });
    }
};

export default reportWebVitals;
